import React, { createContext, useEffect, useState } from 'react';
import dayjs from 'dayjs'
import * as isLeapYear from 'dayjs/plugin/isLeapYear'

export interface IvehData  {
  vin: string;
  vehid: number;
  vehname: string;
  vehname2: string;
  brandid: number;
  modelid: number;
  brandcode: string;
  modelcode: string;
  brandname: string;
  modelname: string;
}
export interface IVehCustInfoContextState {
  activeStep: number;
    vehcustinfodocid: number;
    vehcustinfodoccode: string;
    vin: string;
    allready_exists: boolean;
    saledate: string;  // dayjs.Dayjs|null;
    comments: string;
    custname: string; //  vchr 128  = custname;
    custaddr: string; //  vchr 100  = address;
    custzip: string;  //  vchr  10  = zip;
    custcity: string; //  vchr 50  = city;
    custcountry: string; //  vchr 50 = country;	
    custmobile: string; //  vchr 30  = mobile;
    custemail: string; //  vchr 80   = email;
    docremarks: string;
    vindata: IvehData
}

export const initialVehCustInfoContextState: IVehCustInfoContextState={
  activeStep: 0,
  vehcustinfodocid: 0,
  vehcustinfodoccode: '',
  vin: '',
  allready_exists: false,
  saledate: dayjs(new Date()).toJSON(),
  comments: '',
  custname: '',
  custaddr: '',
  custzip: '',
  custcity: '',  //  vchr 50  = city;
  custcountry: 'Ελλάδα',  //  vchr 50 = country;	
  custmobile: '',  //  vchr 30  = mobile;
  custemail: '',  //  vchr 80   = email;
  docremarks: '',
  vindata: {
    vehid: 0,
    vin: '',
    vehname: '',
    vehname2: '',
    brandid: 0,
    modelid: 0,
    brandcode: '',
    modelcode: '',
    brandname: '',
    modelname: ''
  }
}

//   const { vehCustInfoState, setVehCustInfoContext, resetVehCustInfoContext,getVehCustInfoContext } = React.useContext(VehCustInfoContext)!;


// --------   VehCustInfo       
interface VehCustInfoContextProps {
  vehCustInfoState: IVehCustInfoContextState;
  setVehCustInfoContext: (vhinfostate : IVehCustInfoContextState) => void;
  resetVehCustInfoContext: () => void;
  getVehCustInfoContext: () => IVehCustInfoContextState;
}
export const VehCustInfoContext = createContext<VehCustInfoContextProps | null>(null);

// const or function
const VehCustInfoProvider = ({ children }: { children: React.ReactNode }) => {
    const [vehCustInfoState, setVehCustInfoState] = useState<IVehCustInfoContextState>({...initialVehCustInfoContextState, saledate: dayjs(new Date()).toJSON() });
    useEffect(() => {
      console.log("==* VehCustInfoProvider, useEffect[] ...")
        const storedState = sessionStorage.getItem(`${process.env.REACT_APP_VEHCUSTINFOSESSKEY}`);
        if (storedState) {
          console.log("==* VehCustInfoProvider, useEffect[] storedState=",storedState)
          setVehCustInfoState(JSON.parse(storedState));
        }
    }, []);

    useEffect(() => {
      console.log("==* VehCustInfoProvider, useEffect[vehCustInfo] saving vehCustInfo=",vehCustInfoState)
        sessionStorage.setItem(`${process.env.REACT_APP_VEHCUSTINFOSESSKEY}`, JSON.stringify(vehCustInfoState));
    }, [vehCustInfoState]);

    const resetVehCustInfoContext = () => {
        setVehCustInfoState({...initialVehCustInfoContextState, saledate: dayjs(new Date()).toJSON() });
    };

    const setVehCustInfoContext = (vhinfostate : IVehCustInfoContextState) => {
        console.log("==* VehCustInfoProvider, setVehCustInfoContext to ",vhinfostate)
        setVehCustInfoState(vhinfostate);
    };

    function getVehCustInfoContext(){
      return vehCustInfoState
    }

    //  const incrementCounter = () => {
    //     setAppState((prevState) => ({
    //       ...prevState,
    //       counter: prevState.counter + 1,
    //     }));
    //  };

    return (
        <VehCustInfoContext.Provider
        value={{ vehCustInfoState, setVehCustInfoContext, resetVehCustInfoContext,getVehCustInfoContext }}
        >
        {children}
        </VehCustInfoContext.Provider>
    );
};

export default VehCustInfoProvider;